
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {SancionService} from "@/services/SancionService";
import SancionShow from "@/views/sanciones/SancionShow.vue";
import SancionNew from "@/views/sanciones/SancionNew.vue";
import {Alert} from "@/addons/Alert";
import SancionObservar from "@/views/sanciones/observar.vue";
import router from "@/router";
import {bincardStore} from "@/store/bincardStore";
import {BincardService} from "@/services/BincardService";
import {reporteStore} from "@/store/reporteStore"
import {ReporteService} from "@/services/ReporteService";

@Component({
  name: "CantidadesCalculadasIndex",
  components: {SancionObservar, SancionNew, SancionShow},
})
export default class SancionIndex extends Vue {
  private patterns = Pattern;
  search = null
  cuenta_contable = ''
  private bincardStore = bincardStore();
  private reporteStore = reporteStore();
  private bincardService = BincardService.getInstance();
  private reporteService = ReporteService.getInstance();
  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private sancionSeleccionada: any = null;

  private isObservar = false;



  get materiales(): any[] {
    return this.bincardStore.materialesListado;
  }

  get loading(): boolean {
    return this.bincardStore.loading;
  }

  get pagination(): any {
    return this.bincardStore.pagination;
  }

  get showDialogSancion(): boolean {
    return this.bincardStore.showDialogSancion;
  }

  get cantidadesCalculadas(): any{
    return this.reporteStore.cantidadesCalculadas
  }
  get subtotales(): any{
    return this.reporteStore.subtotales
  }
  get cuentaContable(): any {
    return this.reporteStore.cuentaContable;
  }

  getCuentaContable() {
    this.reporteService.getCuentaContable();
  }

  mounted() {
   this.reporteStore.cantidadesCalculadas = [];
  }


  listar() {
    this.reporteStore.resumenIngresosCuentaContable = [];
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      cuentaContable: this.cuenta_contable,
    };
    this.reporteService.cantidadesCalculadas(data);
  }

  showBincard(material:any){
    router.push({name: 'showBincard', params: {materialEdit: material}})
  }

  imprimir(){
    this.reporteService.imprimir(this.cuenta_contable, this.fechaInicial, this.fechaFinal);
  }
}
